/**
 * Backbone App Games Search Functionality
 * Handles search input and redirects to Backbone app with search query
 */

document.addEventListener('DOMContentLoaded', function () {
  const searchForm = document.getElementById('backbone-games-search-form');
  const searchInput = document.getElementById('backbone-games-search-input');

  if (!searchForm || !searchInput) {
    return;
  }

  /**
   * Handles the search submission
   * @param {string} searchQuery - The search term entered by the user
   */
  function handleSearch(searchQuery) {
    // Trim whitespace and check if query is not empty
    const query = searchQuery.trim();

    if (query === '') {
      return;
    }

    // Encode the search query for URL
    const encodedQuery = encodeURIComponent(query);

    // Redirect to Backbone app with search query
    const backboneAppUrl = `https://app.backbone.com/games/?q=${encodedQuery}`;
    window.open(backboneAppUrl, '_blank');
  }

  // Handle form submission
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    handleSearch(searchInput.value);
  });

  // Handle Enter key press in input field
  searchInput.addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch(searchInput.value);
    }
  });

  // Handle search icon/button click
  const searchButton = searchForm.querySelector('.backbone-app-games__search-icon');
  if (searchButton) {
    searchButton.addEventListener('click', function (e) {
      e.preventDefault();
      handleSearch(searchInput.value);
    });
  }
});
